import { AxiosResponse, CancelTokenSource } from 'axios';
import API from './index';
import moment from 'moment';

const api = new API();

export type SuggestionItemType = {
  date?: moment.Moment;
  isAvailable: boolean;
  isTableAvailable: boolean;
  isEventAvailable: boolean;
  isWaitingListAvailable: boolean;
};

export default class SuggestionAPI extends API {
  getSuggestionsByRestaurantId(
    id: number,
    dateTime: string,
    guests: number,
    cancelToken: CancelTokenSource,
  ): Promise<AxiosResponse<SuggestionItemType[]>> {
    return this._get(`/web/suggestion/restaurant/${id}/${dateTime}/${guests}`, {
      cancelToken: cancelToken.token,
    });
  }

  getAllSuggestionsByRestaurantId(
    id: number,
    dateTime: string,
    guests: number,
    cancelToken: CancelTokenSource,
  ): Promise<AxiosResponse<SuggestionItemType[]>> {
    return this._get(`/web/suggestion/restaurant/${id}/${dateTime}/${guests}/all`, {
      cancelToken: cancelToken.token,
    });
  }

  getAllWaitingListTimesByDate(
    id: number,
    dateTime: string,
    guests: number,
    cancelToken: CancelTokenSource,
  ): Promise<AxiosResponse<SuggestionItemType[]>> {
    return this._get(`/web/suggestion/restaurant/${id}/${dateTime}/${guests}/waitinglisttimes/v2`, {
      cancelToken: cancelToken.token,
    });
  }
}

export const getEventSuggestions: (
  eventId: number,
  restaurantId: number,
  dateTime: string,
  guests: number,
  cancelToken: CancelTokenSource,
) => Promise<AxiosResponse<SuggestionItemType[]>> = (
  eventId,
  restaurantId,
  dateTime,
  guests,
  cancelToken,
) => {
  return api._get(`/web/suggestion/event/${eventId}/${restaurantId}/${dateTime}/${guests}`, {
    cancelToken: cancelToken.token,
  });
};
